import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import patientLang from './locales/patientLang.json';
import orgLang from './locales/orgLang.json';
import editorLang from './locales/editorLang.json';

Vue.use(VueI18n);

// function loadLocaleMessages(): LocaleMessages {
//   const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
//   const messages: LocaleMessages = {};
//   locales.keys().forEach((key: string) => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);
//     if (matched && matched.length > 1) {
//       const locale = matched[1]; // z.B. 'de' or 'en'
//       messages[locale] = locales(key);
//     }
//   });
//   return messages;
// }

function initTranslations() {
  const messages: LocaleMessages = {
    patientLang,
    orgLang,
    editorLang,
  };

  return messages;
}

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: initTranslations(),
  silentTranslationWarn: true,
});
